import { memo, useState } from 'react'
import CategorySearchBox from './CategorySearchBox'
import CarCategoriesTable from '../../../../../tabels/CarCategoriesTable'

function CategoriesBox({ carModels, setCarModels }) {
  const [searchData, setSearchData] = useState('')
  const searchHandler = (value) => {
    setSearchData(value)
  }

  return (
    <>
      <CategorySearchBox search={searchHandler} setCarModels={setCarModels} carModels={carModels} />
      <h2 className={'mt-10 mb-4 text-xl font-medium dark:text-amber-50'}>لیست نوع خودرو ها</h2>
      <CarCategoriesTable search={searchData} carModels={carModels} setCarModels={setCarModels} />
    </>
  )
}

export default memo(CategoriesBox)
